
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13548",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13548",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1183",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10137",
  "foundations-components": "static-1.8784",
  "foundations-components-legacy": "static-1.1809",
  "foundations-theming": "static-1.4989",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8538",
  "hub-http-shared-msw-handlers": "static-1.10941",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11986",
  "I18n": "static-7.1715",
  "jasmine-runner": "static-1.6952",
  "marketplace-discovery-studio-lib": "static-1.944",
  "marketplace-storefront-base": "static-1.13611",
  "quartz": "static-1.7694",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17238",
  "reactive-variable-buffer-atom": "static-1.3351",
  "reporting-testing-lib": "static-1.11372",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13027",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7886",
  "ui-addon-i18n": "static-1.11645",
  "ui-addon-react-router-dom": "static-1.10025",
  "unified-auth": "static-1.1300",
  "unified-auth-core-lib": "static-1.1582",
  "usage-tracker": "static-1.7822",
  "usage-tracker-core": "static-1.7672",
  "customer-data-property-utils": "static-1.8551",
  "hub-http": "static-1.6704",
  "integrations-lib": "static-1.17481",
  "marketplace-ui-common": "static-1.21069",
  "marketplace-ui-install": "static-1.1055",
  "property-management-iframe": "static-1.14506",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quartz-routing": "static-1.1124",
  "quick-fetch": "static-1.4243",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5166",
  "ts-schema": "static-1.4407",
  "ui-universal-auth": "static-1.9786",
  "UIComponents": "static-3.8932",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "bend-plugin-quartz-routing": "static-1.772",
  "ai-components-ui-library": "static-1.10065",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5389",
  "pulse": "static-1.1149",
  "react-codemirror": "static-1.11141",
  "ui-extensions-preview-lib": "static-1.1023",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5053",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2705",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9928",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.111",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5678",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3152",
  "ui-fonts": "static-1.1248",
  "ui-images": "static-2.1282",
  "bend-plugin-foundations-theming": "static-1.3472",
  "foundations-theming-base": "static-1.3974",
  "stylex": "static-1.48",
  "HeadJS": "static-2.829",
  "hs-test-utils-bend-plugin": "static-1.3649",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4805",
  "ui-addon-video-player": "static-1.9122",
  "ai-rendering-library": "static-1.11445",
  "chirp-fetch": "static-1.2403",
  "connections-embed-lib": "static-1.1793",
  "copilot-toolkit": "static-1.12194",
  "feedback-loader": "static-1.30095",
  "laboratory-lib": "static-3.7646",
  "marketplace-embed": "static-1.23242",
  "marketplace-ui-details": "static-1.10964",
  "marketplace-ui-reviews": "static-1.21024",
  "marketplace-ui-tracking": "static-1.15239",
  "sanitize-text": "static-1.8656",
  "usage-tracker-multi": "static-1.6236",
  "usage-tracker-session-replay": "static-1.5508",
  "beacon-keepalive-queue": "static-1.198",
  "quartz-head": "static-1.1359",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5087",
  "immer": "static-1.107",
  "immerable": "static-1.4642",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2858",
  "reporting-data": "static-1.69439",
  "cssUtils": "static-1.1122",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10708",
  "react-dnd-compat": "static-1.5110",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10870",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7812",
  "icons": "static-2.708",
  "marketplace-ui-apps-core": "static-1.19601",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.4999",
  "foundations-components-test-utils": "static-1.6267",
  "quartz-i18n": "static-1.1369",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.788",
  "ads-unified-auth-lib": "static-1.2123",
  "ai-mcp-auth-lib": "static-1.47",
  "custom-vendor-connection-lib": "static-1.350",
  "gemini-settings-lib": "static-1.9825",
  "google-sheets-integration-lib": "static-1.1372",
  "microsoft-drive-auth-lib": "static-1.571",
  "slack-ui-library": "static-1.10898",
  "surveymonkey-integration-lib": "static-1.894",
  "fsm": "static-1.4256",
  "customer-data-objects": "static-1.8209",
  "property-translator": "static-1.5880",
  "hs-locale-management": "static-1.414",
  "frontend-preferences-client": "static-1.8421",
  "hs-promise-utils": "static-1.6090",
  "hubspot-apollo-client": "static-1.5382",
  "integrations-error-boundary-lib": "static-1.14896",
  "integrations-tracking-lib": "static-1.6123",
  "native-integrations-shared-strings": "static-1.8262",
  "sanitize": "static-1.4972",
  "superstore": "static-1.5257",
  "ui-shepherd-react": "static-3.10780",
  "ai-settings-ui-library": "static-1.8629",
  "hub-http-janus": "static-1.913",
  "hubspotter-http": "static-1.4987",
  "immutable-less": "static-1.5151",
  "marketplace-ui-client-types": "static-1.18476",
  "nav-meta": "static-1.30853",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18561",
  "ui-product-approvals-common": "static-1.1663",
  "ai-studio-lib": "static-1.12816",
  "hubspot-prosemirror": "static-1.19322",
  "integrations-reconnect-lib": "static-1.766",
  "ui-addon-iframeable": "static-1.9578",
  "ui-addon-integrations-directory-panel": "static-2.8453",
  "ui-product-approvals": "static-1.29768",
  "ui-tool-access": "static-1.10658",
  "inbound-db-properties-service-client": "static-1.4163",
  "property-management-common": "static-1.6794",
  "opentelemetry-fe-types": "static-1.290",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.665",
  "quartz-auth": "static-1.1369",
  "quartz-test": "static-1.1369",
  "quartz-tracking": "static-1.1073",
  "trellis-components": "static-1.3171",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.576",
  "HubStyle": "static-2.12293",
  "bender-build-tools": "static-1.3617",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24016",
  "ContentUtils": "static-1.69531",
  "customer-data-objects-ui-components": "static-1.13534",
  "sassPrefix": "static-1.387",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2049",
  "bend-plugin-pulse": "static-1.652",
  "event-emitter": "static-1.1461",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5929",
  "magpie-types": "static-1.5389",
  "stylex-utils": "static-1.182",
  "trellis-theming": "static-1.1516",
  "avatar-components": "static-1.2987",
  "breeze-engine-core": "static-1.1534",
  "breeze-engine-lib": "static-1.2256",
  "breeze-onboarding-components": "static-1.1115",
  "customer-data-filters-ui": "static-1.41440",
  "customer-data-reference-ui-components": "static-1.13674",
  "data-integrations-breeze": "static-1.375",
  "embedded-academy-lib": "static-1.16078",
  "ExportDialog": "static-6.10872",
  "global-styles-ai-lib": "static-1.542",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.945",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42457",
  "reporting-snowflake": "static-1.58055",
  "reporting-ui-components": "static-2.66708",
  "reporting-visualizations": "static-1.61513",
  "trial-components-library": "static-1.14423",
  "ui-addon-teams": "static-1.22039",
  "upgrade-components-lib": "static-1.757",
  "navigation-components": "static-1.19216",
  "nest": "static-1.736",
  "simple-logging-lib": "static-1.3551",
  "nudge-client-utils": "static-1.3457",
  "fail-safe": "static-1.448",
  "app-governance-lib": "static-1.2784",
  "developer-experience-shared-components": "static-1.11041",
  "purchase-motions-components": "static-1.6664",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10845",
  "usage-tracker-anonymous": "static-1.6239",
  "usage-tracker-public": "static-1.7633",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3787",
  "persist-promise": "static-1.4206",
  "reference-resolvers": "static-1.8684",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4414",
  "hubspot-apollo-cache": "static-1.841",
  "universal-page-editor-lib": "static-1.3512",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3860",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6953",
  "ui-addon-draggable": "static-3.5250",
  "content-assistance-lib": "static-1.8456",
  "content-media-capture": "static-1.5832",
  "customer-data-ui-utilities": "static-1.10331",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24879",
  "growth-payments-core": "static-1.26545",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3381",
  "payment-link-components": "static-1.24505",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20591",
  "ui-addon-emoji-picker": "static-1.10364",
  "ui-business-units-lib": "static-1.9596",
  "video-components-external": "static-1.12488",
  "video-data-lib": "static-1.36146",
  "navigation-messaging": "static-1.8543",
  "collaboration-sidebar": "static-1.59108",
  "trellis-ext-dnd": "static-1.579",
  "crm-component-utils": "static-1.40256",
  "crm-properties-common-lib": "static-1.6397",
  "customer-data-properties": "static-1.53129",
  "external-options-client-types": "static-1.4451",
  "hs-resources": "static-1.683",
  "property-value-citations": "static-1.3743",
  "reference-resolvers-lite": "static-1.8613",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10939",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5310",
  "content-icons-ui": "static-1.2481",
  "atom": "static-1.5571",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1219",
  "trellis-migration-context": "static-1.78",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1234",
  "breeze-artifacts-sdk": "static-1.1066",
  "breeze-assistant-components": "static-1.2504",
  "getting-started-shared-tasks": "static-1.19604",
  "onboarding-journeys-lib": "static-1.1278",
  "conversations-skeleton-state": "static-1.7618",
  "crm-message-bus": "static-1.44154",
  "customer-data-filters-ui-msw-helpers": "static-1.23875",
  "events-data-lib": "static-1.746",
  "FormUrlGenerator": "static-2.5213",
  "framework-builder-read-service-client": "static-1.4348",
  "multi-account-reference-resolvers": "static-1.1512",
  "onboarding-tours": "static-1.17425",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14809",
  "segments-client-types": "static-1.12254",
  "academy-common-lib": "static-1.15539",
  "dashboard-lib": "static-1.83362",
  "hubspot-prosemirror-plugins": "static-1.19314",
  "reporting-plugins": "static-1.11038",
  "share-with-third-party-component-lib": "static-1.9210",
  "ui-asset-management-lib": "static-1.11602",
  "user-context": "static-1.5554",
  "reporting-reports": "static-1.69115",
  "hubs-service-types": "static-1.1766",
  "purchase-motions-api": "static-1.6667",
  "salesImages": "static-1.756",
  "signup-constants": "static-1.19990",
  "nudge-custom-function-registry": "static-1.3214",
  "nudge-renderer-utils": "static-1.3533",
  "whisper-core-api": "static-1.7675",
  "bend-plugin-fail-safe": "static-1.399",
  "framework-listing-lib": "static-2.29857",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31795",
  "apps-service-types": "static-1.4108",
  "oauth-service-types": "static-1.4636",
  "signup-ui-url-generator": "static-2.8537",
  "onboarding-tours-client": "static-1.5640",
  "one-click-checkout": "static-1.778",
  "platform-infra-nav-components": "static-1.8014",
  "subscription-experience-data-types": "static-1.15469",
  "crm-record-cards-client": "static-1.105",
  "crm-record-cards-service-types": "static-1.3874",
  "framework-data-schema-resolvers": "static-1.7392",
  "location-customization-utils-lib": "static-1.10467",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29608",
  "content-media-composition-data-lib": "static-1.13636",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4929",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3977",
  "seat-types-lib": "static-1.1089",
  "ui-addon-opt": "static-4.8916",
  "commerce-tours-lib": "static-1.6896",
  "growth-onboarding-reliability": "static-1.5582",
  "sales-checkout-service-client": "static-1.4021",
  "data-token-picker": "static-1.17172",
  "FileManagerLib": "static-1.40519",
  "content-media-compositions": "static-2.17643",
  "media-bridge-lib": "static-1.19676",
  "chatspot-widget-iframe": "static-1.24007",
  "collaboration-sidebar-common": "static-1.3905",
  "marketing-platform-lib": "static-1.7405",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38096",
  "crm-actions": "static-1.6885",
  "crm-cards-sdk": "static-1.45076",
  "customer-data-properties-shared-msw-handlers": "static-1.10268",
  "customer-data-tracking": "static-1.7371",
  "calling-global-api": "static-1.66270",
  "calling-internal-common": "static-1.31822",
  "calling-lifecycle-internal": "static-1.67652",
  "calling-lifecycle-messages": "static-1.59944",
  "commerce-products-lib": "static-1.10971",
  "conditional-properties-service-client": "static-1.4126",
  "crm-index-visualization-core": "static-1.4789",
  "crm-links": "static-1.6813",
  "crm-pipelines-api-client-types": "static-1.4456",
  "data-agent-utils": "static-1.969",
  "formula-editor": "static-1.15042",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4527",
  "meetings-icalendar-utils-lib": "static-1.1130",
  "multi-currency-client-types": "static-1.4021",
  "object-builder-ui-client": "static-1.50103",
  "pipeline-validation-client-types": "static-1.4297",
  "react-tinymce": "static-1.56313",
  "smart-data-capture-core": "static-1.531",
  "tiered-pricing": "static-1.2323",
  "tinymce-config": "static-2.55439",
  "tinymce-plugins": "static-1.58553",
  "tinymce-themes": "static-1.57409",
  "topics-actions-lib": "static-1.684",
  "trellis-ext-i18n": "static-1.1423",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.91",
  "fdsr-migration-layer": "static-1.511",
  "breeze-sharing-core": "static-1.41",
  "restore-request-side-panel-lib": "static-1.2080",
  "growth-data-modal": "static-1.6169",
  "growth-onboarding-confetti": "static-1.3557",
  "growth-onboarding-next-action-utils": "static-1.3026",
  "onboarding-tours-utils": "static-1.1492",
  "ui-shepherd-tracker": "static-1.8161",
  "crm-index-associations-lib": "static-1.6948",
  "academy-service-client": "static-1.4190",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40378",
  "SafeStorage": "static-1.4894",
  "video-embed": "static-1.36980",
  "wootric-nps": "static-1.7310",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25287",
  "viral-links-lib": "static-1.7583",
  "campaign-roi-lib": "static-1.10884",
  "campaigns-utils-lib": "static-1.3749",
  "ui-addon-calendars": "static-2.5866",
  "nested-table": "static-1.728",
  "timezone-utils": "static-2.5730",
  "getting-started-shared-tasks-store": "static-1.18722",
  "customer-data-views-management": "static-1.26397",
  "framework-data-table": "static-2.12878",
  "nudge-custom-ui-functions": "static-1.1773",
  "switchboard-lib": "static-1.737",
  "access-check-ui-lib": "static-1.1927",
  "app-users-service-client": "static-1.6120",
  "app-users-service-types": "static-1.5528",
  "mini-checkout-client": "static-1.27873",
  "onboarding-utils": "static-1.5874",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29593",
  "checkout-sdk": "static-3.24716",
  "payment-method-components": "static-1.7343",
  "touchless-buying-components": "static-1.6584",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.890",
  "framework-data-schema-quick-fetch": "static-1.7297",
  "growth-onboarding-feedback-components": "static-1.7080",
  "audio-components": "static-1.6607",
  "FileManagerImages": "static-1.38030",
  "video-components": "static-1.14490",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20535",
  "commerce-shared-components-lib": "static-1.19618",
  "commerce-tools-ui-lib": "static-1.11366",
  "crm_data": "static-4.93254",
  "crm-activity-creator-data": "static-1.47797",
  "crm-fe-perf": "static-1.23399",
  "universal-record-utils-lib": "static-1.2412",
  "calling-error-reporting": "static-1.31829",
  "shared-worker-versioning": "static-1.11542",
  "calling-usage-tracker": "static-1.7040",
  "voice-sms-access-library": "static-1.2526",
  "commerce-permissions": "static-1.1287",
  "products-iframe-lib": "static-1.8959",
  "products-ui-components-shared-msw-handlers": "static-1.11323",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11024",
  "sales-views-client-types": "static-1.4757",
  "data-agent-kit": "static-1.956",
  "enrichment-settings-lib": "static-1.291",
  "policy-lib": "static-1.7303",
  "bark-lib": "static-1.17034",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3531",
  "interframe": "static-3.5242",
  "tinymce-data": "static-1.41524",
  "ui-addon-sales-email": "static-1.5702",
  "layout-dnd-components": "static-1.13263",
  "layout-dnd-utils": "static-1.12238",
  "ui-brand-identity-lib": "static-1.17004",
  "NamespacedHubStyle": "static-2.9380",
  "onboarding-data-sync-lib": "static-1.2872",
  "growth-onboarding-next-action-components": "static-1.3054",
  "user-context-client": "static-1.5009",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5013",
  "outpost": "static-1.4629",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22394",
  "sales-email-signature-service-client": "static-1.4348",
  "copilot-messaging": "static-1.2444",
  "ts-utils-lib": "static-1.650",
  "crm-export-dialog": "static-1.6777",
  "crm-index-ui-shimmer": "static-1.3033",
  "crm-view-components": "static-1.1553",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7838",
  "tasks-actions-lib": "static-1.477",
  "InboxConnectUtils": "static-4.15882",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.887",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4487",
  "company-details-components": "static-1.6706",
  "react-performance-metrics-lib": "static-1.1050",
  "pricing-pages-ui-components": "static-1.16665",
  "quote-checkout-service-types": "static-1.3958",
  "social-insights-client-types": "static-1.22970",
  "utility-belt": "static-1.3037",
  "payments-enrollment-embed-lib": "static-1.24279",
  "stripe-embedded-components": "static-1.8283",
  "customer-data-rte": "static-1.33940",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6571",
  "payments-post-enroll-local-storage-lib": "static-1.5605",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39214",
  "crm_universal": "static-1.22760",
  "customer-data-email": "static-1.18677",
  "meetings-rte-lib": "static-1.581",
  "universal-associations-select": "static-1.11596",
  "crm-object-search-query-utilities": "static-1.10499",
  "calling-orchestration-schema": "static-1.37303",
  "react-reducer-toolkit": "static-1.16708",
  "ContentData": "static-1.69606",
  "layout-data-lib": "static-1.10563",
  "meetings-connect-utils-lib": "static-1.8119",
  "company-details-service-types": "static-1.4444",
  "segments-query-core": "static-1.1930",
  "pricing-pages-api": "static-1.16530",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29194",
  "sequences-lib": "static-1.8823",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4090",
  "meetings-core": "static-1.803",
  "advanced-menus-core": "static-1.15853",
  "advanced-menus-lib": "static-1.12597",
  "ui-memberships-settings-lib": "static-1.35242",
  "sequences-client-types-lib": "static-1.8680",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15852",
  "simple-menus-lib": "static-1.17369"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13548",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1183",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10137",
  "foundations-components": "/foundations-components/static-1.8784",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1809",
  "foundations-theming": "/foundations-theming/static-1.4989",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8538",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10941",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11986",
  "I18n": "/I18n/static-7.1715",
  "jasmine-runner": "/jasmine-runner/static-1.6952",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.944",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13611",
  "quartz": "/quartz/static-1.7694",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17238",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3351",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11372",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13027",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7886",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11645",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10025",
  "unified-auth": "/unified-auth/static-1.1300",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1582",
  "usage-tracker": "/usage-tracker/static-1.7822",
  "usage-tracker-core": "/usage-tracker-core/static-1.7672",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8551",
  "hub-http": "/hub-http/static-1.6704",
  "integrations-lib": "/integrations-lib/static-1.17481",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21069",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1055",
  "property-management-iframe": "/property-management-iframe/static-1.14506",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quick-fetch": "/quick-fetch/static-1.4243",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5166",
  "ts-schema": "/ts-schema/static-1.4407",
  "ui-universal-auth": "/ui-universal-auth/static-1.9786",
  "UIComponents": "/UIComponents/static-3.8932",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.772",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10065",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5389",
  "pulse": "/pulse/static-1.1149",
  "react-codemirror": "/react-codemirror/static-1.11141",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1023",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5053",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2705",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9928",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5678",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3152",
  "ui-fonts": "/ui-fonts/static-1.1248",
  "ui-images": "/ui-images/static-2.1282",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3472",
  "foundations-theming-base": "/foundations-theming-base/static-1.3974",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.829",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3649",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4805",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9122",
  "ai-rendering-library": "/ai-rendering-library/static-1.11445",
  "chirp-fetch": "/chirp-fetch/static-1.2403",
  "connections-embed-lib": "/connections-embed-lib/static-1.1793",
  "copilot-toolkit": "/copilot-toolkit/static-1.12194",
  "feedback-loader": "/feedback-loader/static-1.30095",
  "laboratory-lib": "/laboratory-lib/static-3.7646",
  "marketplace-embed": "/marketplace-embed/static-1.23242",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10964",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21024",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15239",
  "sanitize-text": "/sanitize-text/static-1.8656",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6236",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5508",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.198",
  "quartz-head": "/quartz-head/static-1.1359",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5087",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4642",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2858",
  "reporting-data": "/reporting-data/static-1.69439",
  "cssUtils": "/cssUtils/static-1.1122",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10708",
  "react-dnd-compat": "/react-dnd-compat/static-1.5110",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10870",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7812",
  "icons": "/icons/static-2.708",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19601",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.4999",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6267",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.788",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2123",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.47",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.350",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9825",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1372",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.571",
  "slack-ui-library": "/slack-ui-library/static-1.10898",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.894",
  "fsm": "/fsm/static-1.4256",
  "customer-data-objects": "/customer-data-objects/static-1.8209",
  "property-translator": "/property-translator/static-1.5880",
  "hs-locale-management": "/hs-locale-management/static-1.414",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8421",
  "hs-promise-utils": "/hs-promise-utils/static-1.6090",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5382",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14896",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6123",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8262",
  "sanitize": "/sanitize/static-1.4972",
  "superstore": "/superstore/static-1.5257",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10780",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8629",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hubspotter-http": "/hubspotter-http/static-1.4987",
  "immutable-less": "/immutable-less/static-1.5151",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18476",
  "nav-meta": "/nav-meta/static-1.30853",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18561",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1663",
  "ai-studio-lib": "/ai-studio-lib/static-1.12816",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19322",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.766",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9578",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8453",
  "ui-product-approvals": "/ui-product-approvals/static-1.29768",
  "ui-tool-access": "/ui-tool-access/static-1.10658",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4163",
  "property-management-common": "/property-management-common/static-1.6794",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.290",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.665",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-test": "/quartz-test/static-1.1369",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "trellis-components": "/trellis-components/static-1.3171",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.576",
  "HubStyle": "/HubStyle/static-2.12293",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24016",
  "ContentUtils": "/ContentUtils/static-1.69531",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13534",
  "sassPrefix": "/sassPrefix/static-1.387",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2049",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.652",
  "event-emitter": "/event-emitter/static-1.1461",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5929",
  "magpie-types": "/magpie-types/static-1.5389",
  "stylex-utils": "/stylex-utils/static-1.182",
  "trellis-theming": "/trellis-theming/static-1.1516",
  "avatar-components": "/avatar-components/static-1.2987",
  "breeze-engine-core": "/breeze-engine-core/static-1.1534",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2256",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1115",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41440",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13674",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.375",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16078",
  "ExportDialog": "/ExportDialog/static-6.10872",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.542",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.945",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42457",
  "reporting-snowflake": "/reporting-snowflake/static-1.58055",
  "reporting-ui-components": "/reporting-ui-components/static-2.66708",
  "reporting-visualizations": "/reporting-visualizations/static-1.61513",
  "trial-components-library": "/trial-components-library/static-1.14423",
  "ui-addon-teams": "/ui-addon-teams/static-1.22039",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.757",
  "navigation-components": "/navigation-components/static-1.19216",
  "nest": "/nest/static-1.736",
  "simple-logging-lib": "/simple-logging-lib/static-1.3551",
  "nudge-client-utils": "/nudge-client-utils/static-1.3457",
  "fail-safe": "/fail-safe/static-1.448",
  "app-governance-lib": "/app-governance-lib/static-1.2784",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11041",
  "purchase-motions-components": "/purchase-motions-components/static-1.6664",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10845",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6239",
  "usage-tracker-public": "/usage-tracker-public/static-1.7633",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3787",
  "persist-promise": "/persist-promise/static-1.4206",
  "reference-resolvers": "/reference-resolvers/static-1.8684",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4414",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.841",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3512",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3860",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6953",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5250",
  "content-assistance-lib": "/content-assistance-lib/static-1.8456",
  "content-media-capture": "/content-media-capture/static-1.5832",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10331",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24879",
  "growth-payments-core": "/growth-payments-core/static-1.26545",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3381",
  "payment-link-components": "/payment-link-components/static-1.24505",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20591",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10364",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9596",
  "video-components-external": "/video-components-external/static-1.12488",
  "video-data-lib": "/video-data-lib/static-1.36146",
  "navigation-messaging": "/navigation-messaging/static-1.8543",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59108",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.579",
  "crm-component-utils": "/crm-component-utils/static-1.40256",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6397",
  "customer-data-properties": "/customer-data-properties/static-1.53129",
  "external-options-client-types": "/external-options-client-types/static-1.4451",
  "hs-resources": "/hs-resources/static-1.683",
  "property-value-citations": "/property-value-citations/static-1.3743",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8613",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10939",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5310",
  "content-icons-ui": "/content-icons-ui/static-1.2481",
  "atom": "/atom/static-1.5571",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1219",
  "trellis-migration-context": "/trellis-migration-context/static-1.78",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1234",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1066",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2504",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19604",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1278",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7618",
  "crm-message-bus": "/crm-message-bus/static-1.44154",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23875",
  "events-data-lib": "/events-data-lib/static-1.746",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5213",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4348",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1512",
  "onboarding-tours": "/onboarding-tours/static-1.17425",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14809",
  "segments-client-types": "/segments-client-types/static-1.12254",
  "academy-common-lib": "/academy-common-lib/static-1.15539",
  "dashboard-lib": "/dashboard-lib/static-1.83362",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19314",
  "reporting-plugins": "/reporting-plugins/static-1.11038",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9210",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11602",
  "user-context": "/user-context/static-1.5554",
  "reporting-reports": "/reporting-reports/static-1.69115",
  "hubs-service-types": "/hubs-service-types/static-1.1766",
  "purchase-motions-api": "/purchase-motions-api/static-1.6667",
  "salesImages": "/salesImages/static-1.756",
  "signup-constants": "/signup-constants/static-1.19990",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3214",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3533",
  "whisper-core-api": "/whisper-core-api/static-1.7675",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.399",
  "framework-listing-lib": "/framework-listing-lib/static-2.29857",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31795",
  "apps-service-types": "/apps-service-types/static-1.4108",
  "oauth-service-types": "/oauth-service-types/static-1.4636",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8537",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5640",
  "one-click-checkout": "/one-click-checkout/static-1.778",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8014",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15469",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.105",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3874",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7392",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10467",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29608",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13636",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4929",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3977",
  "seat-types-lib": "/seat-types-lib/static-1.1089",
  "ui-addon-opt": "/ui-addon-opt/static-4.8916",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6896",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5582",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4021",
  "data-token-picker": "/data-token-picker/static-1.17172",
  "FileManagerLib": "/FileManagerLib/static-1.40519",
  "content-media-compositions": "/content-media-compositions/static-2.17643",
  "media-bridge-lib": "/media-bridge-lib/static-1.19676",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24007",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3905",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7405",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38096",
  "crm-actions": "/crm-actions/static-1.6885",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45076",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10268",
  "customer-data-tracking": "/customer-data-tracking/static-1.7371",
  "calling-global-api": "/calling-global-api/static-1.66270",
  "calling-internal-common": "/calling-internal-common/static-1.31822",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67652",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59944",
  "commerce-products-lib": "/commerce-products-lib/static-1.10971",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4126",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4789",
  "crm-links": "/crm-links/static-1.6813",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4456",
  "data-agent-utils": "/data-agent-utils/static-1.969",
  "formula-editor": "/formula-editor/static-1.15042",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4527",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1130",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4021",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50103",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4297",
  "react-tinymce": "/react-tinymce/static-1.56313",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.531",
  "tiered-pricing": "/tiered-pricing/static-1.2323",
  "tinymce-config": "/tinymce-config/static-2.55439",
  "tinymce-plugins": "/tinymce-plugins/static-1.58553",
  "tinymce-themes": "/tinymce-themes/static-1.57409",
  "topics-actions-lib": "/topics-actions-lib/static-1.684",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1423",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.91",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.511",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.41",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2080",
  "growth-data-modal": "/growth-data-modal/static-1.6169",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3557",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3026",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1492",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8161",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6948",
  "academy-service-client": "/academy-service-client/static-1.4190",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40378",
  "SafeStorage": "/SafeStorage/static-1.4894",
  "video-embed": "/video-embed/static-1.36980",
  "wootric-nps": "/wootric-nps/static-1.7310",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25287",
  "viral-links-lib": "/viral-links-lib/static-1.7583",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10884",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3749",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5866",
  "nested-table": "/nested-table/static-1.728",
  "timezone-utils": "/timezone-utils/static-2.5730",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18722",
  "customer-data-views-management": "/customer-data-views-management/static-1.26397",
  "framework-data-table": "/framework-data-table/static-2.12878",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1773",
  "switchboard-lib": "/switchboard-lib/static-1.737",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1927",
  "app-users-service-client": "/app-users-service-client/static-1.6120",
  "app-users-service-types": "/app-users-service-types/static-1.5528",
  "mini-checkout-client": "/mini-checkout-client/static-1.27873",
  "onboarding-utils": "/onboarding-utils/static-1.5874",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29593",
  "checkout-sdk": "/checkout-sdk/static-3.24716",
  "payment-method-components": "/payment-method-components/static-1.7343",
  "touchless-buying-components": "/touchless-buying-components/static-1.6584",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.890",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7297",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7080",
  "audio-components": "/audio-components/static-1.6607",
  "FileManagerImages": "/FileManagerImages/static-1.38030",
  "video-components": "/video-components/static-1.14490",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20535",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19618",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11366",
  "crm_data": "/crm_data/static-4.93254",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47797",
  "crm-fe-perf": "/crm-fe-perf/static-1.23399",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2412",
  "calling-error-reporting": "/calling-error-reporting/static-1.31829",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11542",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7040",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2526",
  "commerce-permissions": "/commerce-permissions/static-1.1287",
  "products-iframe-lib": "/products-iframe-lib/static-1.8959",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11323",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11024",
  "sales-views-client-types": "/sales-views-client-types/static-1.4757",
  "data-agent-kit": "/data-agent-kit/static-1.956",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.291",
  "policy-lib": "/policy-lib/static-1.7303",
  "bark-lib": "/bark-lib/static-1.17034",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3531",
  "interframe": "/interframe/static-3.5242",
  "tinymce-data": "/tinymce-data/static-1.41524",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5702",
  "layout-dnd-components": "/layout-dnd-components/static-1.13263",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12238",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17004",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9380",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2872",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3054",
  "user-context-client": "/user-context-client/static-1.5009",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5013",
  "outpost": "/outpost/static-1.4629",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22394",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4348",
  "copilot-messaging": "/copilot-messaging/static-1.2444",
  "ts-utils-lib": "/ts-utils-lib/static-1.650",
  "crm-export-dialog": "/crm-export-dialog/static-1.6777",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3033",
  "crm-view-components": "/crm-view-components/static-1.1553",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7838",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.477",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15882",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.887",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4487",
  "company-details-components": "/company-details-components/static-1.6706",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1050",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16665",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3958",
  "social-insights-client-types": "/social-insights-client-types/static-1.22970",
  "utility-belt": "/utility-belt/static-1.3037",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24279",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8283",
  "customer-data-rte": "/customer-data-rte/static-1.33940",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6571",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5605",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39214",
  "crm_universal": "/crm_universal/static-1.22760",
  "customer-data-email": "/customer-data-email/static-1.18677",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.581",
  "universal-associations-select": "/universal-associations-select/static-1.11596",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10499",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37303",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16708",
  "ContentData": "/ContentData/static-1.69606",
  "layout-data-lib": "/layout-data-lib/static-1.10563",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8119",
  "company-details-service-types": "/company-details-service-types/static-1.4444",
  "segments-query-core": "/segments-query-core/static-1.1930",
  "pricing-pages-api": "/pricing-pages-api/static-1.16530",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29194",
  "sequences-lib": "/sequences-lib/static-1.8823",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4090",
  "meetings-core": "/meetings-core/static-1.803",
  "advanced-menus-core": "/advanced-menus-core/static-1.15853",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12597",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35242",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8680",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15852",
  "simple-menus-lib": "/simple-menus-lib/static-1.17369"
}
};
